/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thin_Dry_Slug_WaitInputs */

const en_thin_dry_slug_wait = /** @type {(inputs: Thin_Dry_Slug_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For each selected feedback group a separate entry is created using that group's question text.`)
};

const de_thin_dry_slug_wait = /** @type {(inputs: Thin_Dry_Slug_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für jede ausgewählte Feedback-Gruppe wird ein eigener Eintrag mit dem jeweiligen Fragetext erstellt.`)
};

/**
* | output |
* | --- |
* | "For each selected feedback group a separate entry is created using that group's question text." |
*
* @param {Thin_Dry_Slug_WaitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const thin_dry_slug_wait = /** @type {((inputs?: Thin_Dry_Slug_WaitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thin_Dry_Slug_WaitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thin_dry_slug_wait(inputs)
	return de_thin_dry_slug_wait(inputs)
});